import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';

import { GeneralAdmissionMessage } from '../GeneralAdmissionMessage';
import { rawFetch } from '../shared/utils/rawFetch';
import { VenueMapProps } from '../VenueMapProps';
import VenueMapV3Content from './VenueMapV3Content';

const domParser = new DOMParser();

export const VenueMapV3 = ({
  isGeneralAdmissionOnly,
  svgMapUrl,
  ...rest
}: VenueMapProps) => {
  if (!svgMapUrl) {
    throw new Error('svgMapUrl not available');
  }

  const mapQuery = useQuery({
    queryKey: [svgMapUrl],
    queryFn: () =>
      rawFetch(svgMapUrl, {}).then((text: string) => {
        if (!text) {
          throw Error('Failed to get venue map : ' + svgMapUrl);
        }
        const s = domParser.parseFromString(text, 'image/svg+xml');

        const svgElement = s.children[0];
        svgElement.setAttribute(
          'width',
          ref?.current?.clientWidth?.toString() ?? '0'
        );
        svgElement.setAttribute(
          'height',
          ref?.current?.clientHeight?.toString() ?? '0'
        );
        const serializer = new XMLSerializer();
        return {
          svg: serializer.serializeToString(svgElement),
        };
      }),

    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  const ref = useRef<HTMLDivElement>(null);

  const { svg } = mapQuery.data ?? {};

  if (isGeneralAdmissionOnly) {
    return <GeneralAdmissionMessage />;
  }

  if (!svg) {
    return <div style={{ width: '100%', height: '100%' }} ref={ref}></div>;
  }

  return (
    <VenueMapV3Content ref={ref} svg={svg} svgMapUrl={svgMapUrl} {...rest} />
  );
};
